import React, { useState } from 'react';
import { TextArea } from '../../../common/sharedComponents/TextArea';
import {
  DatePickerContainer,
  MyAuditCommentsContainer,
} from './styled.MyAuditConduct';
import { useTranslation } from 'react-i18next';
import { IMyAuditConductComments } from './../../../@types/myAuditConductComments';
import { MealPeriodDropdown } from '../../../myAudit/components/MealPeriodDropdown';
import { SearchBoxTaggedUsers } from '../../../myAudit/components/SearchBoxTaggedUsers';
import { Body5 } from '../../../common/typography';
import { DatePickerWrapper } from '../../../common/sharedStyledComponents/Datepicker.styled';
import { DatePickerDate } from '../../../common/sharedComponents/DatePickerDate';
import { DatePickerDateTime } from '../../../common/sharedComponents/DatePickerDateTime';
import { DatePickerDateRange } from '../../../common/sharedComponents/DatePickerDateRange';
import { convertTaggedUsersInitialState } from '../../../myAudit/utils';
import { showErrorMessage } from '../../../../helpers/showMessage';

export function MyAuditConductComments ({
  section,
  handleOutletName,
  handleRoomNumber,
  handleMealPeriod,
  handleTaggedUsers,
  startDate,
  setStartDate,
  dateTime,
  setDateTime,
  startDateRange,
  setStartDateRange,
  endDateRange,
  setEndDateRange,
  handleMyAuditComments,
}: IMyAuditConductComments) {
  const { t } = useTranslation();

  const [roomNumberError, setRoomNumberError] = useState(false);
  const [outletNameError, setOutletNameError] = useState(false);

  const isShowRoomsNumber = section.showRoomNumber;
  const isOutletIncluded = section.isOutletIncluded;
  const isMealPeriod = section.isMealPeriod;
  const tagged = section.tagged;

  const isDatePickerDate =
    section.isDateTimeRequired && section.dateTimeFormat === 'date';

  const isDatePickerDateTime =
    section.isDateTimeRequired && section.dateTimeFormat === 'dateTime';

  const isDatePickerDateRange =
    section.isDateTimeRequired && section.dateTimeFormat === 'dateOnlyRange';

  const isDateTime =
    isDatePickerDateTime || isDatePickerDateRange || isDatePickerDate;

  return (
    <>
      <MyAuditCommentsContainer>
        <SearchBoxTaggedUsers
          callBackSelectedOptions={handleTaggedUsers}
          initialState={convertTaggedUsersInitialState(tagged)}
        />
        {isDateTime && (
          <DatePickerContainer>
            <Body5 color="eerieBlack">
              {t('COMMON.MY_AUDIT.CONDUCT.DATE.TITLE')}
            </Body5>
            <DatePickerWrapper>
              {isDatePickerDate && (
                <DatePickerDate
                  startDate={startDate}
                  setStartDate={setStartDate}
                />
              )}
              {isDatePickerDateTime && (
                <DatePickerDateTime
                  startDate={dateTime}
                  setStartDate={setDateTime}
                />
              )}
              {isDatePickerDateRange && (
                <DatePickerDateRange
                  startDate={startDateRange}
                  setStartDate={setStartDateRange}
                  endDate={endDateRange}
                  setEndDate={setEndDateRange}
                />
              )}
            </DatePickerWrapper>
          </DatePickerContainer>
        )}
        <TextArea
          title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.MY_AUDIT_COMMENTS.TITLE')}
          textValue={section.comments}
          placeholder={t(
            'COMMON.MY_AUDIT.CONDUCT.COMMENTS.MY_AUDIT_COMMENTS.PLACEHOLDER'
          )}
          onValueChange={handleMyAuditComments}
        />
        {isShowRoomsNumber && (
          <TextArea
            title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.ROOM_NUMBER.TITLE')}
            textValue={section.roomNumber}
            placeholder={t(
              'COMMON.MY_AUDIT.CONDUCT.COMMENTS.ROOM_NUMBER.PLACEHOLDER'
            )}
            maxLength={50}
            isError={roomNumberError}
            onValueChange={(newValue: string) => {
              if (newValue.length > 50) {
                setRoomNumberError(true);
                showErrorMessage(t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.ROOM_NUMBER.MAX_LENGTH_ERROR') || 'Max 50 characters allowed');
                return;
              } else {
                setRoomNumberError(false);
              }
              handleRoomNumber(newValue);
            }}
          />
        )}
        {isOutletIncluded && (
          <TextArea
            title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.OUTLET.TITLE')}
            textValue={section.outletName}
            placeholder={t(
              'COMMON.MY_AUDIT.CONDUCT.COMMENTS.OUTLET.PLACEHOLDER'
            )}
            maxLength={50}
            isError={outletNameError}
            onValueChange={(newValue: string) => {
              if (newValue.length > 50) {
                setOutletNameError(true);
                showErrorMessage(t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.OUTLET.MAX_LENGTH_ERROR') || 'Max 50 characters allowed');
                return;
              } else {
                setOutletNameError(false);
              }
              handleOutletName(newValue);
            }}
          />
        )}
        {isMealPeriod && (
          <MealPeriodDropdown handleMealPeriod={handleMealPeriod} />
        )}
      </MyAuditCommentsContainer>
    </>
  );
}
